import { useState } from 'react'
import { Text, useWindowSize } from '../../../../modules/Dashboard'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import MobileModal from '../../../../components/layouts/MobileModal'
import CardLayout from '../../../../components/layouts/CardLayout'
import PairImg from '../PairImg'
import { usePredictContext } from '../../context/PredictContextProvider'
import { ReactComponent as NexaImg } from '../../../../assets/images/trading-pro/nexa.svg'
import NexaChart from './NexaChart'

const ResultHeader = ({ coin, date }) => {
    const { assistant } = usePredictContext()
    const { width } = useWindowSize()
    const [aboutModal, setAboutModal] = useState(false)

    return (
        <div className='rtl:flex-row-reverse lg:mb-[80px]'>
            <CardLayout className='w-full flex items-start justify-between gap-16  lg:max-h-[300px] relative border border-secondaryColor/70 '>
                <img src={require('../../assets/result-header-banner.webp')} alt='header-banner' className='hidden w-[30%] max-w-[250px] lg:block rounded-3xl ltr:rounded-br-[100px] rtl:rounded-bl-[100px]' width={443} height={601} />
                <div className='flex flex-col justify-center col-start-2 gap-4 w-full flex-1'>
                    <div className="flex flex-wrap gap-2 text-3xl md:text-4xl text-center lg:text-start break-words w-full ">
                        <Text tid="result-of" className="text-center lg:text-start" />
                        <span className="text-secondaryColor text-center lg:text-start"> {coin} </span>
                        <Text tid={assistant.assistant.value} className='text-wrap text-center lg:text-start' />
                        <Text tid="analysis" className='text-center lg:text-start' />
                    </div>
                    <Text
                        className='text-lg md:text-xl text-center lg:text-start w-full break-words whitespace-pre-line text-wrap'
                        tid={assistant.assistant.tickerCase === 'forex' ? "result-forex-header" : "result-crypto-header"}
                        dynamicTid={{ assistant: assistant.assistant.value, pair: coin }} />

                    {/* <PairSelectCompact /> */}
                </div>
            </CardLayout>
            {
                width <= MOBILE_SIZE &&
                <MobileModal isOpen={aboutModal} onClose={() => setAboutModal(false)}>
                    <div className='p-3 flex flex-col gap-4'>
                        <div className='flex justify-center items-center gap-2'>
                            <PairImg ticker={coin} size={35} />
                            <Text tid={`${coin?.split('-')[0]}`} />
                        </div>
                        <Text tid={`about-coin.${coin?.split('-')[0]}`} />
                    </div>
                </MobileModal>
            }
        </div>
    )
}

export default ResultHeader